<template>
  <oie-interactive-list-item :class="['user-item', {'user-item--is-awaiting-accept-invite': user.isAwaitingAcceptInvite}]">
    <template #media>
      <oie-base-icon icon="user-avatar" size="l"></oie-base-icon>
    </template>
    <template #content>
      <div>
        <div class="body user-item__text">
          <div>
            <p class="caption">
              {{ tStatic('user') }}
            </p>
            <button
              :disabled="user.isAwaitingAcceptInvite"
              :aria-label="`Open user ${user.name}`"
              class="body user-item__open"
              @click.stop="$emit('select-user', user)">
              <template v-if="user.name">
                {{ user.name }}
              </template>
              <span v-else class="body-italic">
                {{ tStatic('noName') }}
              </span>
            </button>
          </div>
          <div>
            <p class="caption">
              {{ tStatic('email') }}
            </p>
            <p>{{ user.email }}</p>
          </div>
          <div>
            <p class="caption">
              {{ tStatic('alias') }}
            </p>
            <p>{{ user.alias }}</p>
          </div>
        </div>
        <div class="user-item__labels">
          <oie-base-label
            v-for="(label, index) in user.labels"
            :key="index"
            :text="label.text"
            :is-type="label.type"></oie-base-label>
        </div>
      </div>
    </template>
    <template #actions>
      <oie-base-action
        v-if="user.isAwaitingAcceptInvite"
        theme="destructive"
        @click.stop="$emit('cancel-invite', user)">
        {{ t('myUsersCancelInviteButtonLabel') }}
      </oie-base-action>
    </template>
  </oie-interactive-list-item>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
.user-item__text {
  display: flex;
  gap: measure(half);
  margin-bottom: measure(half);
  flex-direction: column;

  @container interactive-list-item (min-width: 600px) {
    flex-direction: row;
    gap: measure(double);

    &>*:first-child {
      flex: 0 0 9rem;
      overflow-wrap: anywhere;
    }
  }
}

.user-item:not(.user-item--is-awaiting-accept-invite):hover {
  background-color: color(blue-5);

  .user-item__open {
    text-decoration: underline;
  }
}

.user-item__open {
  @include reset-button;
  text-align: left;
}

.user-item__open::after {
  content: "";
  position: absolute;
  top:0;
  bottom: 0;
  left: 0;
  right: 0;
}

.user-item__labels {
  display: flex;
  gap: measure(eighth);
}
</style>
